import { boxMatchesStyle } from '../../../shared/boxes/styleTemplate';

/**
 * Choix d'un modèle, en vignettes plutôt qu'en liste déroulante — même
 * principe que la galerie de styles du site et que le sélecteur de
 * dispositions du document : on voit ce qu'on choisit.
 *
 * Le modèle surligné se DÉDUIT des valeurs de la box : rien n'est persisté qui
 * dise lequel est actif, et un réglage à la main sort simplement de la
 * sélection.
 */
const BoxStyleTemplatePicker = ({ styles, props, onApply, renderPreview }) => (
  <div style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(96px, 1fr))',
    gap: 8,
    width: '100%',
  }}>
    {styles.map((style) => {
      const selected = boxMatchesStyle(props, style);
      return (
        <button
          key={style.id}
          type="button"
          title={typeof style.name === 'string' ? style.name : undefined}
          onClick={() => onApply(style)}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            padding: 6,
            cursor: 'pointer',
            background: 'white',
            borderRadius: 6,
            border: `1.5px solid ${selected ? 'var(--primary-color, #0b2239)' : 'rgba(11, 34, 57, 0.12)'}`,
            boxShadow: selected ? '0 0 0 2px var(--primary-color-light, rgba(11,34,57,0.2))' : 'none',
          }}
        >
          <div style={{
            // Vignette : la box en réduction, pas un dessin approximatif.
            width: '100%',
            height: 64,
            overflow: 'hidden',
            pointerEvents: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{ transform: 'scale(0.28)', transformOrigin: 'center' }}>
              {renderPreview(style)}
            </div>
          </div>
          <span style={{
            fontSize: 10,
            lineHeight: 1.2,
            textAlign: 'center',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}>
            {style.name}
          </span>
        </button>
      );
    })}
  </div>
);

export default BoxStyleTemplatePicker;
